import React from 'react';
import DraggableHeaderCell from './DraggableHeaderCell';

const DraggableContainer = (props: any) => {
  const renderGrid = () => {
    return React.Children.map(props.children, (child) => {
      return React.cloneElement(child, {
        draggableHeaderCell: DraggableHeaderCell,
      });
    })[0];
  };

  return <div style={{ display: 'block' }}>{React.cloneElement(renderGrid(), props)}</div>;
};

export default DraggableContainer;
